module.exports = __webpack_public_path__ + "static/media/1POLICY2.eb6aaf0a.jpg";